<div class="toolbar-grid">
  <div class="layout-row" [hidden]="interactionModeIsCanvas$ | async">
    @if ((interactionModeIsCanvas$ | async) === false) {
      <h3-secondary-toolbar-2d-objectless
        *h3Injector="contentInjector"
      ></h3-secondary-toolbar-2d-objectless>
    }

    <div class="output-controls">
      <h3-vector-tagging-layer-view-settings *h3Injector="contentInjector">
        <h3-vector-tagging-layer-view-settings-popover
          *h3Injector="contentInjector"
        ></h3-vector-tagging-layer-view-settings-popover>
      </h3-vector-tagging-layer-view-settings>

      <h3-inspect-button></h3-inspect-button>

      <h3-undo-redo-buttons
        *ngIf="(readOnly$ | async) !== true"
      ></h3-undo-redo-buttons>

      <h3-help-button></h3-help-button>
      <h3-show-feedback-button></h3-show-feedback-button>
      <h3-right-collapsing-button
        *ngIf="(this.isRightPanelExpanded$ | async) === false"
      ></h3-right-collapsing-button>
    </div>
  </div>
  <div class="layout-row" [hidden]="interactionModeIsCanvas$ | async">
    <h3-main-vector-tagging-toolbar
      *h3Injector="contentInjector"
    ></h3-main-vector-tagging-toolbar>
  </div>
  <h3-coordinates-box *h3Injector="contentInjector"></h3-coordinates-box>
</div>
